// export const media = {
//   mobile: (...args) => `
//       @media (max-width: 768px) {
//         ${args.join("")}
//       }
//     `,
//   web: (...args) => `
//       @media (min-width: 769px) {
//         ${args.join("")}
//       }
//     `,
// };

import { css } from "styled-components";

export const media = {
  mobile: (...args) => css`
    @media (max-width: 768px) {
      ${css(...args)}
    }
  `,
  web: (...args) => css`
    @media (min-width: 769px) {
      ${css(...args)}
    }
  `,
};
